import React, { Component } from 'react';
import { APP_CONST } from '../../../../constants';
import { GeckoFields, GeckoAlert } from '../../../../components';
import GeckoField from '../../../../components/field/field';
import Commands from '../ModuleTwoFactor/Commands';

export class ModuleBasic extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mfaWarning: false
        };

        this.removePhoneNumber = this.removePhoneNumber.bind(this);
        this.renderRemoveNumber = this.renderRemoveNumber.bind(this);
        this.showMfaWarning = this.showMfaWarning.bind(this);
    }

    handleChange(name, evt) {
        this.setState({[name]: evt});
    }

    fields()
    {
        return [{
            label: 'First name',
            key: 'first_name',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_TEXT,
        },{
            label: 'Last name',
            key: 'last_name',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_TEXT,
        },{
            label: 'Email address',
            key: 'email',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_EMAIL,
        },{
            label: 'Phone number',
            key: 'number',
            width: '100%',
            disabledWhen: () => true,
            type: APP_CONST.FIELD_TYPE_TEL,
        },];
    }

    renderRemoveNumber() {
        if (!this.props.data || !this.props.data.user) {
            return null;
        }

        const user = this.props.data.user;

        if (!this.hasPhoneNumber(user)) {
            return null;
        }

        if (this.hasMfaConfigured(user) && this.hasPhoneNumber(user)) {
            return <a className="text-xs text-muted-foreground hover:text-foreground cursor-pointer" onClick={this.showMfaWarning}>Remove phone number</a>
        }

        if (!this.hasMfaConfigured(user) && this.hasPhoneNumber(user)) {
            return <a className="text-xs text-muted-foreground hover:text-foreground cursor-pointer" onClick={this.removePhoneNumber}>Remove phone number</a>
        }
    }

    showMfaWarning() {
        this.setState({ mfaWarning: true });
    }

    removePhoneNumber() {
        return Commands.setPhoneNumber('')
        .then(() => {
            this.props.iam();
        })
        .catch((err) => {
            this.props.setAlert(err.message);
        });
    }

    getValues()
    {
        if(!this.props.data || !this.props.data.user) {
            return {}
        }

        const user_data = this.props.data.user;
        const provider_data = (user_data.provider ? user_data.provider : {});

        return {
            first_name: user_data.FirstName,
            last_name: user_data.LastName,
            email: user_data.Email,
            number: provider_data.phone_number ? provider_data.phone_number : '',
        }
    }

     hasMfaConfigured(user) {
        if (user && user.provider && user.provider.UserMFASettingList) {
            return true;
        }

        return false;
    }
    
    hasPhoneNumber(user) {
        if (user && user.provider && user.provider.phone_number) {
            return true;
        }

        return false;
    }  

    render() {
        const fields = this.fields();
        const phoneField = fields.find(f => f.key === 'number');
        const otherFields = fields.filter(f => f.key !== 'number');
        const user = this.props.data && this.props.data.user ? this.props.data.user : null;
        const showMfaWarning = this.state.mfaWarning && user && this.hasMfaConfigured(user) && this.hasPhoneNumber(user);

        return (
            <div className="flex flex-col gap-4">
                <GeckoFields 
                    fields={otherFields}
                    values={this.getValues()}
                    handler={this.handleChange.bind(this)}
                    submitHandler={() => {}} />
                
                {phoneField && (
                    <div className="flex flex-col gap-2">
                        <GeckoField 
                            field={phoneField} 
                            values={this.getValues()} 
                            handler={this.handleChange.bind(this)} 
                        />
                        {this.renderRemoveNumber()}
                        {showMfaWarning && (
                            <GeckoAlert type={APP_CONST.ALERT_TYPE_WARNING}>
                                Disable MFA before removing phone number
                            </GeckoAlert>
                        )}
                    </div>
                )}
            </div>
        )
    }
}

ModuleBasic.defaultProps = {
    data: {},
    setAlert: () => null,
    iam: () => null,
}

export default ModuleBasic;